// extracted by mini-css-extract-plugin
module.exports = {"documentPreviewCanvas":"DocumentPdfView_documentPreviewCanvas__3uGS6","responsive":"DocumentPdfView_responsive__271On","canvasLink":"DocumentPdfView_canvasLink__2xHNu"};